export default __webpack_public_path__ + "static/media/73@2x-8.908ceba9.png";